export default __webpack_public_path__ + "static/media/user-icon.0ccefe64.svg";